import { StyleSheet } from 'react-native';

import { EPGConfig } from '../types';

const getStyles = (config: EPGConfig) =>
    StyleSheet.create({
        container: {
            position: 'absolute',
            top: 0,
            right: 0,
            left: 0,
            height: config.timebarHeight,
        },

        list: {
            height: config.timebarHeight,
        },

        listContent: {
            paddingLeft: config.channelWidth,
            alignItems: 'center',
        },

        markerStyle: {
            position: 'absolute',
            top: 0,
            left: 0,
            bottom: 0,
            alignItems: 'center',
            justifyContent: 'center',
        },
    });

export default getStyles;
